import { energyUnitConversionsMetricToUSCS } from './unit-conversion.constant';

export function isMetricEnergyUnit(unit: string): boolean {
  return Object.keys(energyUnitConversionsMetricToUSCS).includes(unit);
}
